import React from "react";
import "./styles/therapy.css";
import coupleTrees from "../../assets/couple-trees.jpg"; // Replace with your actual image path
import trees from "../../assets/trees.mp4"; // Placeholder path for your video
import ServiceWarning from "../../components/ServiceWarning";

const CoupleTherapy = () => {
  return (
    <section className="therapy-section">
      <div className="therapy-card">
        <div className="video-banner">
          <video className="therapy-video" autoPlay muted loop playsInline>
            <source src={trees} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>

        <div className="therapy-content">
          <h1>Couple Therapy</h1>
          <p>
            I recognize that relationships are at the heart of our emotional
            well-being and daily functioning—they shape how we experience
            safety, connection, and belonging in the world. Couples therapy
            provides an opportunity to explore and strengthen your relational
            dynamics in a supportive, non-judgmental space.
          </p>
          <p>
            My work with couples integrates emotion-focused and attachment-based
            frameworks to address patterns of disconnection, recurring conflict,
            communication difficulties, intimacy issues, and the impact of past
            trauma on relationships. Treatment begins with an extended joint
            session of 85 minutes, followed by individual meetings with each
            partner and culminates in a shared session where we review a
            collaborative treatment plan for our work together.
          </p>
          <p>
            I welcome and affirm diverse relationship structures and work
            respectfully with couples across a wide range of identities and
            lived experiences.
          </p>
        </div>

        <div className="bottom-image-wrapper">
          <img
            src={coupleTrees}
            alt="couple therapy"
            className="therapy-image"
          />
        </div>
      </div>
      <ServiceWarning />
    </section>
  );
};

export default CoupleTherapy;
